import * as React from 'react';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

import MediaCard from './MediaCard';
import mediaImage from '../images/pexels-monstera.jpeg';

export default function ProgramAccordions({programs}) {


	const RenderMediaCard =programs?.map(program => (<MediaCard key={program.id} {...program} />))

	return (
		<Grid container justifyContent='center' sx={{background:"", padding:"44px 0", gap:"24px"}}>
			{/* <MediaCard mediaImage={mediaImage} />
      <MediaCard mediaImage={mediaImage} />
      <MediaCard mediaImage={mediaImage} /> */}
      {RenderMediaCard}
		</Grid>
	);
}
